"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderComponents = exports.toggleDropdown = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'changeStatus', false), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.wizard.errors &&
            this.props.wizard.errors['recipients'] &&
            (!prevProps.wizard.errors || !prevProps.wizard.errors['recipients'])) {
            return this.props.sendErrorToast();
        }
    }
}), recompose_1.pure);
var toggleDropdown = function (props) { return function () {
    return props.changeStatus(!props.isOpen);
}; };
exports.toggleDropdown = toggleDropdown;
exports.HeaderComponents = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('buttons/previous'), icon: React.createElement(Icon_1.Icon, { className: 'fa-chevron-left' }), disabled: props.wizard.wizardStep < 1 || props.wizard.wizardStep > 1, onClick: props.changeStep(props)(props.wizard.wizardStep - 1 > -1 ? props.wizard.wizardStep - 1 : 0) }),
    React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('buttons/next'), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-chevron-right' }), disabled: props.wizard.wizardStep > 0, onClick: props.changeStep(props)(props.wizard.wizardStep + 1 < 2 ? props.wizard.wizardStep + 1 : 1) }),
    React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)('buttons/save'), iconRight: React.createElement(Icon_1.Icon, { className: 'fa-save' }), disabled: props.wizard.wizardStep < 1 ||
            props.wizard.isSaving === 'SAVED' ||
            props.wizard.isSaving === 'SAVING', onClick: function () {
            var next = props.wizard.wizardStep + 1 < 3 ? props.wizard.wizardStep + 1 : 2;
            props.changeStep(props)(next)();
        } }),
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), onClick: function () {
            return props.wizard.wizardStep === 2
                ? props.distributionReady(props.currentProject)()
                : props.cancel();
        } }))); });
